import { type DesignDocument, designDocumentSchema } from '@repo/api-contracts';

/**
 * 에디터 임시 작업 보관 키(U2·G13). 상품별이라 다른 상품에 적용되지 않는다.
 * localStorage 라 탭을 닫아도 같은 기기에 남는다 — 회원(로그인 전 편집)·비회원(견적 요청 화면으로 넘김) 공통.
 */
export const draftKey = (productId: string): string => `customize-draft:${productId}`;

export const saveDraft = (productId: string, document: DesignDocument): void => {
  try {
    localStorage.setItem(draftKey(productId), JSON.stringify(document));
  } catch {
    // 보관 실패는 저장·요청 흐름을 막지 않는다 — 다시 열 때 복원만 못 한다.
  }
};

/** 계약 파싱에 실패하거나 상품이 다르면 null — 깨진 보관본은 조용히 버린다. */
export const loadDraft = (productId: string): DesignDocument | null => {
  try {
    const raw = localStorage.getItem(draftKey(productId));
    if (raw === null) return null;
    const parsed = designDocumentSchema.safeParse(JSON.parse(raw));
    return parsed.success && parsed.data.productId === productId ? parsed.data : null;
  } catch {
    return null;
  }
};

export const clearDraft = (productId: string): void => {
  try {
    localStorage.removeItem(draftKey(productId));
  } catch {
    // 무시
  }
};
